/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";

/** Common Components */
import NoRecordFound from "../../../../../../components/ui/noRecordFound/NoRecordFound";
import CenterModel from "../../../../../../components/ui/centerModel/CenterModel";
import { useLazyGetAttachedTaskByTaskIdQuery } from "../../../../../../app/services/attachedTaskAPI";
import NewReferenceTaskList from "./newReferenceTaskList/NewReferenceTaskList";

/** CSS Files */
import "./NewReferenceTask.scss";

const NewReferenceTask = ({ projectId, taskId }, ref) => {
  const [showPopup, setShowPopup] = useState(false);
  const [taskData, settaskData] = useState([]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleSuccess = () => {
    handleClosePopup();
  };

  const [
    getAttachedTaskByTaskId,
    {
      isSuccess: isAttachedTaskByTaskIsSuccess,
      data: AttachedTaskByTaskIdData,
    },
  ] = useLazyGetAttachedTaskByTaskIdQuery();

  useEffect(() => {
    if (taskId) {
      getAttachedTaskByTaskId(taskId);
    }
  }, [taskId]);

  useEffect(() => {
    if (isAttachedTaskByTaskIsSuccess && AttachedTaskByTaskIdData) {
      settaskData(AttachedTaskByTaskIdData);
    }
  }, [isAttachedTaskByTaskIsSuccess, AttachedTaskByTaskIdData]);

  useImperativeHandle(ref, () => ({
    refreshAttachedTasks: () => {
      if (ref) {
        getAttachedTaskByTaskId(taskId);
      }
    }
  }), [taskId]);

  return (
    <>
      <div className="reference-tasks">
        <div className="reference-body">
          {taskData && taskData.length > 0 ? (
            <>
              <div className="reference-progress">
                <span>
                  {taskData.length} linked to this task
                </span>
              </div>
              <div className="reference-list">
                {taskData.map((item) => (
                  <div
                    className="reference-tasks-card"
                    key={item.linkedTaskId}
                    title={item.title}
                  >
                    <div className="reference-card-top">
                      <span className="reference-title">{`TM${item.linkedTaskId}`}</span>
                    </div>
                    <div className="reference-description">{item.title}</div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="no-data-found">
              <NoRecordFound message="No linked tasks yet — attach one to get started" />
            </div>
          )}
        </div>
      </div>

      {showPopup && (
        <CenterModel
          showModal={showPopup}
          className="header-task-center-model attach-task-center-model"
          handleToggleModal={handleClosePopup}
          modalTitle="Attach Task"
          modelSizeClass="w-55"
        >
          <NewReferenceTaskList
            isOpen={showPopup}
            onSuccess={handleSuccess}
            onClose={handleClosePopup}
            projectId={projectId}
            taskId={taskId}
            getAttachedTaskByTaskId={getAttachedTaskByTaskId}
          />
        </CenterModel>
      )}
    </>
  );
};

export default forwardRef(NewReferenceTask);
